import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Tab from "../Components/Tab";
import { useMainContext } from "../Context";
const MainLayoutPages = ({ children }) => {
  const { isLogin } = useMainContext();
  const navigate = useNavigate();

  let loc = useLocation()
  useEffect(() => {
    if(window.ReactNativeWebView){
      window.ReactNativeWebView.postMessage(loc.pathname)
    }
  }, [loc])


  if (isLogin()) {
    return (
      <>
        <div
          style={{
            paddingBottom: "70px",
          }}
        >
          {children}
        </div>
        <div
          className="container-fl"
          style={{
            position: "fixed",
            bottom: "0",
            width: "100%",
            left: 0,
            right: 0,
            zIndex: 9999,
          }}
        >
          <div className="row justify-content-center">
            <div className="col-md-11">
              <Tab />
            </div>
          </div>
        </div>
      </>
    );
  } else {
    window.location.replace("/check");

    return <></>;
  }
};

export default MainLayoutPages;
